import { useFormatDateRange } from "@/hooks";
import { useT } from "@/i18n";
import { getAvatarPlaceholderUrl } from "@/utils/common";

import { TournamentSearchItem } from "../GlobalSearch.types";
import { GlobalSearchItemTypeChip } from "../GlobalSearchItemTypeChip";
import { SearchItemDescription, SearchItemLabel } from "../SearchItemLabel";

export type TournamentSearchItemViewProps = {
  item: TournamentSearchItem;
};

export const TournamentSearchItemView = ({ item }: TournamentSearchItemViewProps) => {
  const t = useT();
  const formatDateRange = useFormatDateRange();

  const dateRange =
    item.startDate || item.endDate
      ? formatDateRange(
          { start: item.startDate, end: item.endDate },
          { month: "short", day: "2-digit", year: "numeric" }
        )
      : null;

  return (
    <div className="flex items-center justify-between w-full gap-2">
      <div className="flex items-center gap-4 flex-2 min-w-0">
        <img
          src={item.tournament.logo || getAvatarPlaceholderUrl(item.tournament.title)}
          alt={item.tournament.title}
          aria-label={item.tournament.title}
          width={30}
          height={30}
          className="shrink-0 object-contain rounded-sm"
        />
        <div className="flex flex-col min-w-0 flex-1">
          <SearchItemLabel>{item.tournament.title}</SearchItemLabel>
          <SearchItemDescription>
            {dateRange
              ? t("general.globalSearch.tournament.subtitleWithDates", {
                  dateRange,
                })
              : t("general.globalSearch.tournament.subtitle")}
          </SearchItemDescription>
        </div>
      </div>
      <div className="flex items-center shrink-0 gap-1">
        <GlobalSearchItemTypeChip type="tournament" />
      </div>
    </div>
  );
};
